export default "__VITE_ASSET__BKwQRJgC__"